import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle } from 'recompose'
import { push } from 'react-router-redux'
import { track } from 'utils/trackingUtils'

import * as UserSelectors from 'modules/user/selectors'
import * as UserActions from 'modules/user/actions'
import FindMyTeamVerify from './component'

const mapStateToProps = state => ({
  email: UserSelectors.getEmail(state),
  sentEmail: UserSelectors.findMyTeamVerificationEmailStatus(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setValidEmail: UserActions.setValidEmail,
    setEmail: UserActions.setEmail,
    sendFindMyTeamVerificationEmail: UserActions.sendFindMyTeamVerificationEmail,
    push,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidUpdate() {
      if (this.props.sentEmail === 'success') {
        this.props.actions.push('/start/findTeam/sent')
      }
    },
  }),
  withHandlers({
    onEmailChange: props => event => {
      props.actions.setEmail(event.target.value)
    },
    onContinueClick: props => () => {
      track('Onboarding Find My Team Completed', {
        context: 'email verification sent'
      })
      props.actions.sendFindMyTeamVerificationEmail()
    }
    },
  )
)(FindMyTeamVerify)



// WEBPACK FOOTER //
// ./src/layouts/FindMyTeam/FindMyTeamVerify/index.js